import {
  Component,
  OnInit,
  style,
  trigger,
  animate,
  transition,
} from "@angular/core";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatSnackBar,
} from "@angular/material";
import { Router } from "@angular/router";
import { IMyOptions, IMyDateModel } from "mydatepicker";
import { SessionStorage } from "ngx-webstorage";
import { DeletePopUpComponent } from "../../common/delete-pop-up/delete-pop-up.component";
import { ExportExcelService } from "../../utils/services/export-excel.service";
import { ProjectService } from "./project.service";
import { ExportCSV, ExportMultiCSV, UpdateProject } from "./project";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { ProjectIPDOExport, projectList } from "../reports/report";
import { AddProjectService } from "./add-project/add-project.service";

@Component({
  selector: "app-project",
  templateUrl: "./project.component.html",
  styleUrls: ["./project.component.css"],
  animations: [
    trigger("enterAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("500ms ease-in", style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class ProjectComponent implements OnInit {
  @SessionStorage() public userObj;
  @SessionStorage() public user;
  @SessionStorage() public config;

  public projectlistarr: projectList[] = []; // Array of project list available in the system
  public projectlistoriginalarr: projectList[] = []; // Copy of an array of project list available in the system
  public projectSearch: string; // Variable to hold the search term
  public pageNumber: number = 1; // Variable to hold the current page number for pagination
  public totalElements: any = 0; // Total project count to set pagination controls
  public myDatePickerOptions: IMyOptions; // Date Picker Config
  public myDatePickerEndOptions: IMyOptions; // Date Picker Config
  public empOpen: boolean; // To check if employee list is opened or not
  public exportData: Array<any> = []; // Array of data for export to csv
  public totalProjectCount: number = 1;

  constructor(
    private projectService: ProjectService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private exportExcel: ExportExcelService,
    private spinnerService: Ng4LoadingSpinnerService,
    private addProjectService:AddProjectService
  ) {
    this.myDatePickerOptions = {
      dateFormat: "dd-mm-yyyy",
      markCurrentDay: true,
      openSelectorTopOfInput: true,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: false,
      inline: false,
    };

    this.myDatePickerEndOptions = {
      dateFormat: "dd-mm-yyyy",
      markCurrentDay: true,
      openSelectorTopOfInput: true,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: false,
      inline: false,
      disableUntil: { year: 2017, month: 12, day: 28 },
    };
  }

  ngOnInit() {
    this.getProjectLists();
  }

  /* Get all the project list from the backend */
  getProjectLists() {
    this.projectlistarr = [];
    this.projectlistoriginalarr = [];
    this.spinnerService.show();
    this.projectService.getProjectList(this.pageNumber).subscribe(
      (data) => {
        this.spinnerService.hide();
        this.totalElements = data.payload.totalProjects;
        this.totalProjectCount = data.payload.totalProjects;
        if (data.payload.projects) {
          data.payload.projects.map((value) => {
            this.projectlistarr.push(new projectList(value));
            this.projectlistoriginalarr.push(new projectList(value));
          });
        }
      },
      (error) => {
        this.spinnerService.hide();
      }
    );
  }

  /* Navigating to add project view */
  addProject() {
    this.router.navigate(["/admin/project/add-project"]);
  }

  /* Deleting the project iff edit modal is not opened */
  deleteProject(data, flag) {
    if (!flag) {
      // Check if edit window is closed
      if (this.dialog.openDialogs.length === 0) {
        const dialogRef = this.dialog.open(DeletePopUpComponent);
        dialogRef.afterClosed().subscribe((result) => {
          if (result == true) {
            // const data = { userObj: this.userObj };

            let projecInfo = {
              project: {
                projectID: data.projectID,
                Project: data.projectName,
                wbsCode: data.wbsCode,
                startDate: data.startDate,
                endDate: data.endDate,
                plannedHour: data.plannedHours,
                projectType: data.projectType,
                projectManager: data.projectManager,
              },
            };

            projecInfo["employess"] = data.empDetails.map((p) => {
              p.empdetails.isDeleted = true;
              return p.empdetails;
            });

            this.projectService.deleteProject(projecInfo).subscribe(
              (response) => {
                this.snackBar.open("Project Deleted Successfully", "OK", {
                  duration: 3000,
                });
                this.getProjectLists();
                this.addProjectService.triggerAPI(data).subscribe((response) => {
                  const responseBody = JSON.parse(response._body); // Parse the _body property as JSON
                  const message = responseBody.Message; // Access the Message field from the parsed JSON
                  console.log(message);
                 this.snackBar.open("Response From Control Panel: " + message, "OK", {
                 duration: 60000,
                  });
                }
                ,
                (error) => {
                  console.error("Error triggering API:", error);
                  this.snackBar.open("Error triggering API", "OK", {
                    duration: 3000,
                  });
                }
                )
              },
              (error) => {
                this.snackBar.open("Error Deleting Project ", "OK", {
                  duration: 3000,
                });
              }
            );
          }
        });
      }
    }
  }
  /* Update the Project upon click of edit icon */
  updateProject(proj: any) {
    this.router.navigate([`/admin/project/add-project/${proj.projectID}`]);
    // let count = 0;
    // this.projectlistarr.filter(ele => ele.editMode === true).map(ele => count++);
    // if (count === 0) { // check if not other popup is open
    //   const startDate = this.projectlistarr[i].startDate.split('-');
    //   this.myDatePickerEndOptions.disableUntil = {
    //     year: parseInt(startDate[0], 10),
    //     month: parseInt(startDate[1], 10),
    //     day: parseInt(startDate[2], 10)
    //   };
    //   this.projectlistarr[i].editMode = !this.projectlistarr[i].editMode;
    // }
  }

  /*Function to show project details */
  showProjectDetail(project) {
    if (project.arrowclicked === true) {
      project.arrowclicked = false;
    } else {
      this.projectlistarr.forEach((element) => {
        element.arrowclicked = false;
      });
      project.arrowclicked = true;
    }
  }

  /* Update the Project from the Edit popup */
  updatedetails(i) {
    // Check the time range is valid or not
    if (this.projectlistarr[i].Project) {
      if (this.projectlistarr[i].originalstartDateobj.formatted) {
        this.projectlistarr[i].originalstartDateobj.formatted =
          this.projectlistarr[i].originalstartDateobj.formatted
            .split("-")
            .reverse()
            .join("-");
        this.projectlistarr[i].originalstartDateobj.epoc = new Date(
          this.projectlistarr[i].originalstartDateobj.formatted
        );
        this.projectlistarr[i].originalstartDateobj.epoc =
          this.projectlistarr[i].originalstartDateobj.epoc.getTime();
      }
      if (this.projectlistarr[i].originalendDateobj.formatted) {
        this.projectlistarr[i].originalendDateobj.formatted =
          this.projectlistarr[i].originalendDateobj.formatted
            .split("-")
            .reverse()
            .join("-");
        this.projectlistarr[i].originalendDateobj.epoc = new Date(
          this.projectlistarr[i].originalendDateobj.formatted
        );
        this.projectlistarr[i].originalendDateobj.epoc =
          this.projectlistarr[i].originalendDateobj.epoc.getTime();
      }

      if (
        this.projectlistarr[i].originalstartDateobj.formatted &&
        this.projectlistarr[i].originalendDateobj.formatted
      ) {
        if (
          this.projectlistarr[i].originalstartDateobj.epoc <
          this.projectlistarr[i].originalendDateobj.epoc
        ) {
          // Check if required field is filled
          if (
            this.projectlistarr[i].Project != "" &&
            this.projectlistarr[i].originalstartDateobj != null
          ) {
            this.projectlistarr[i].editMode = false;
            const data = new UpdateProject(
              this.projectlistoriginalarr[i],
              this.projectlistarr[i],
              this.userObj
            );
            this.projectService.updateProject(data).subscribe(
              (response) => {
                this.snackBar.open("Project Updated Successfully", "OK", {
                  duration: 3000,
                  extraClasses: ["textCenter"],
                });
                this.getProjectLists();
              },
              (error) => {
                this.snackBar.open("Please check the Project name", "OK", {
                  duration: 3000,
                  extraClasses: ["textCenter"],
                });
              }
            );
          } else {
            this.snackBar.open("Please fill all the field", "OK", {
              duration: 3000,
              extraClasses: ["textCenter"],
            });
            this.getProjectLists();
          }
        } else {
          this.snackBar.open("Start date should be less than end date", "OK", {
            duration: 3000,
            extraClasses: ["textCenter"],
          });
        }
      } else if (this.projectlistarr[i].originalstartDateobj.formatted) {
        if (
          this.projectlistarr[i].Project != "" &&
          this.projectlistarr[i].originalstartDateobj != null
        ) {
          this.projectlistarr[i].editMode = false;
          const data = new UpdateProject(
            this.projectlistoriginalarr[i],
            this.projectlistarr[i],
            this.userObj
          );
          this.projectService.updateProject(data).subscribe(
            (response) => {
              this.snackBar.open("Project Updated Successfully", "OK", {
                duration: 3000,
                extraClasses: ["textCenter"],
              });
              this.getProjectLists();
            },
            (error) => {
              this.snackBar.open("Please check the Project name", "OK", {
                duration: 3000,
                extraClasses: ["textCenter"],
              });
            }
          );
        } else {
          this.snackBar.open("Please fill all the field", "OK", {
            duration: 3000,
            extraClasses: ["textCenter"],
          });
          this.getProjectLists();
        }
      }
    } else {
      this.snackBar.open("Please fill all the Project name", "OK", {
        duration: 3000,
        extraClasses: ["textCenter"],
      });
    }
  }

  /* Function to check selected data */
  checkSearchData(e) {
    if (!this.projectSearch) {
      // this.pageNumber = 1;
      this.totalElements = this.totalProjectCount;
      this.projectlistarr = this.projectlistoriginalarr;
    }
  }

  /* Search for Project in the view */
  applySearch() {
    let searchString = this.projectSearch.trim();
    if (searchString.length > 0) {
      this.projectlistarr = [];
      // this.projectlistoriginalarr = [];
      this.projectService.searchFilter(searchString).subscribe((response) => {
        if (response.payload) {
          this.totalElements = response.payload.length
            ? response.payload.length
            : 0;
          response.payload.map((value) => {
            this.projectlistarr.push(new projectList(value));
            // this.projectlistoriginalarr.push(new projectList(value));
          });
        }
      });
    } else {
      this.projectSearch = "";
    }
  }

  /* Function to get the project list on pagination change */
  triggerChange(data: any) {
    this.pageNumber = data;
    if (this.projectSearch) {
      this.applySearch();
    } else {
      this.getProjectLists();
    }
  }

  /* Set the end date when start date changes */
  startDateChange(event, projectInfo) {
    this.myDatePickerEndOptions = JSON.parse(
      JSON.stringify(this.myDatePickerEndOptions)
    );
    this.myDatePickerEndOptions.disableUntil = event.date;
  }

  /* Get the data for csv download for complete project list */
  exportToXsl() {
    this.spinnerService.show();
    this.projectService.getXslData("project/listFilter", {}).subscribe(
      (response) => {
        this.spinnerService.hide();
        let data = response.payload.projects.map((p) => new projectList(p));
        this.exportToCsv(data, "Project", "Projects");
      },
      (error) => {
        this.spinnerService.hide();
        this.snackBar.open("Error occured while exporting", "OK", {
          duration: 3000,
        });
      }
    );
  }

  /* Export the data to csv file */
  exportToCsv(data, type, Project) {
    const fileName = "Project";
    this.exportData = [];
    if (data.length > 0) {
      if (type === "Single Export") {
        // For each project dowload
        data.map((element, index) =>
          this.exportData.push(new ExportCSV(element, index))
        );
      } else {
        // For complete Project list download
        data.map((element, index) => {
          if (element.empDetails.length > 0) {
            element.empDetails.forEach((e) => {
              this.exportData.push(
                new ProjectIPDOExport(
                  e,
                  element,
                  index,
                  this.config.businessUnit
                )
              );
            });
          } else {
            this.exportData.push(
              new ProjectIPDOExport(
                {
                  empdetails: {},
                },
                element,
                index,
                this.config.businessUnit
              )
            );
          }
        });
      }
      this.exportExcel.JSONToCSVConvertor(
        this.exportData,
        fileName,
        Project,
        true,
        true
      );
    }
  }

  /* Single Download csv file  */
  getProjectDetials(rowData, ProjectDetails) {
    let Project;
    if (
      this.config.businessUnit === "ipdo" ||
      this.config.businessUnit === "biologics" ||
      this.config.businessUnit === "chinateam" ||
      this.config.businessUnit == "aps"
    ) {
      Project =
        ProjectDetails.Project +
        ` ( Planned Hours: ${ProjectDetails.proj_plannedHour} / Total Spent Hours: ${ProjectDetails.spentTotal} )`;
    } else {
      Project = ProjectDetails.Project;
    }
    if (rowData.length > 0) {
      this.exportToCsv(rowData, "Single Export", Project);
    } else {
      this.snackBar.open("No Employee Details to Export", "OK", {
        duration: 3000,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/project/project.component.ts